module.exports = __webpack_public_path__ + "static/media/bag.fbe6c00e.svg";